import { createUseStyles } from 'react-jss'

export default createUseStyles({
  content: {
    padding: 25
  }
})
